import controller from './response.controller';
import template from './template/response.view.html';
import templateAD from './template/response.adaptative.view.html';

let ResponseComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

function changeTemplate() {
    if(__env.adaptative){
      return templateAD;
    } else {
      return template;
    }
  }

export default ResponseComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/response/response.component.js
 **/